/**
 * new-meeting-messages — user-facing strings for the "New meeting" dialog (Task #9).
 *
 * Same convention as weekly-report-messages.ts: no i18n runtime exists yet, so this module is the
 * single source of the dialog's copy and no English is inlined in JSX.
 */
export const newMeetingMessages = {
  title: "New meeting",
  description:
    "Create a meeting for this project. It joins the project's meeting timeline and meeting-intelligence analysis.",
  logDescription:
    "Record a meeting that was held outside DeliverPro so it appears on the project's meeting timeline.",
  opensInNewTab: "opens in a new tab",
  matchingHint:
    "DeliverPro sets the Teams meeting title for you. Keep it unchanged so the recording links to this meeting automatically.",
  linkHint:
    "Paste the Avoma recording link to bring the transcript into meeting intelligence, or any https meeting link (Teams, Zoom, Google Meet) as evidence.",

  mode: {
    legend: "What do you want to do?",
    schedule: "Schedule a new meeting",
    log: "Log a meeting that already happened",
  },

  fields: {
    name: "Meeting name",
    phase: "Phase",
    scope: "Audience",
    date: "Date and time (optional)",
    time: "Time",
    link: "Meeting link",
    loggedDate: "Date held (optional)",
  },

  scope: {
    internal: "Internal",
    customer: "Customer",
  },

  placeholders: {
    name: "e.g. Architecture Deep Dive",
    phase: "Select phase…",
    date: "Select a date",
    link: "https://app.avoma.com/meetings/…",
  },

  actions: {
    newMeeting: "New meeting",
    create: "Create meeting",
    log: "Log meeting",
    cancel: "Cancel",
    done: "Done",
    openTeams: "Create in Teams",
  },

  errors: {
    nameTooShort: "Meeting name must be at least 3 characters.",
    nameTooLong: "Meeting name must be at most 120 characters.",
    namePipe: 'Meeting name cannot contain "|".',
    phaseRequired: "Select a phase.",
    dateTimeIncomplete: "Choose both a date and a time, or leave both empty.",
    linkRequired: "Paste the meeting link.",
    linkHttps: "The link must start with https://.",
    linkTooLong: "The link must be at most 2000 characters.",
  },

  success: {
    title: "Meeting created",
    description:
      "Now create it in Teams. The title below is pre-filled so the recording links back to this project.",
    subjectLabel: "Teams meeting title",
  },

  status: {
    created: "Meeting created",
    logged: "Meeting logged",
    createFailure: "Failed to create meeting",
  },
} as const;

export default newMeetingMessages;
